import React from 'react';
import styled from 'styled-components';

import { IMaskInput } from 'react-imask';
import { input } from '../utils/styles';

const Input = styled(IMaskInput)`
  ${input};
`;

const InputMask = props => {
  return <Input mask={'+{0}(000) 000 00 00'} autoComplete="off" lazy {...props} />;
};

export default InputMask;



// WEBPACK FOOTER //
// ./src/components/InputPhone.js